import { Link } from "react-router-dom";
import { categories } from "@/mocks/events";

export default function Footer() {
  return (
    <footer className="mt-20 bg-secondary-950 text-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-xl text-background-50"></i>
              </span>
              <span className="font-heading text-lg font-black text-background-50">瓜田热评</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/70">
              不只看热闹，更看神评论。聚合热门吃瓜事件与网友热评，把评论区里最有意思的观点挑出来给你看。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
              逛瓜田
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link className="text-background-100/70 transition-colors hover:text-accent-300" to="/">
                  围观现场
                </Link>
              </li>
              <li>
                <Link className="text-background-100/70 transition-colors hover:text-accent-300" to="/events">
                  瓜田广场
                </Link>
              </li>
              <li>
                <Link className="text-background-100/70 transition-colors hover:text-accent-300" to="/comments">
                  神评榜
                </Link>
              </li>
              <li>
                <Link className="text-background-100/70 transition-colors hover:text-accent-300" to="/about">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
              热门分类
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories
                .filter((c) => c.key !== "all")
                .map((c) => (
                  <li key={c.key}>
                    <Link
                      className="text-background-100/70 transition-colors hover:text-accent-300"
                      to={`/events?cat=${c.key}`}
                    >
                      {c.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
              加入吃瓜群
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-background-100/70">
              订阅瓜田日报，每天一封短邮件，把当天最值得看的事件和神评送到你手上。
            </p>
            <Link
              to="/about"
              className="mt-4 inline-flex whitespace-nowrap items-center rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-mail-send-line mr-1.5 text-base"></i>
              立即订阅
            </Link>
            <p className="mt-5 flex items-center gap-2 text-xs text-background-100/60">
              <i className="ri-mail-line text-sm"></i>
              hello@guatian-hotcomment.cc
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start gap-3 border-t border-background-50/10 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 瓜田热评 · 围观现场内容聚合平台</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容仅为网友观点整理，不代表本站立场</span>
            <span className="hidden sm:inline">·</span>
            <span>理性吃瓜，友善发言</span>
          </p>
        </div>
      </div>
    </footer>
  );
}